import React, { useState } from 'react';
import { PlayIcon, PauseIcon, RefreshCwIcon, CalendarIcon, ClockIcon, PlusIcon } from 'lucide-react';
export function IntegrationsSyncsTab() {
  const syncs = [{
    id: 1,
    name: 'Salesforce Accounts Sync',
    connection: 'Salesforce Production',
    direction: 'Bidirectional',
    schedule: 'Every 1 hour',
    lastRun: '10 minutes ago',
    nextRun: 'In 50 minutes',
    status: 'active',
    recordsProcessed: 1247,
    duration: '2m 34s'
  }, {
    id: 2,
    name: 'HubSpot Contacts Import',
    connection: 'HubSpot',
    direction: 'Inbound',
    schedule: 'Every 30 minutes',
    lastRun: '15 minutes ago',
    nextRun: 'In 15 minutes',
    status: 'active',
    recordsProcessed: 892,
    duration: '1m 12s'
  }, {
    id: 3,
    name: 'Marketo Leads Export',
    connection: 'Marketo',
    direction: 'Outbound',
    schedule: 'Daily at 2:00 AM',
    lastRun: '8 hours ago',
    nextRun: 'In 16 hours',
    status: 'active',
    recordsProcessed: 3421,
    duration: '5m 18s'
  }, {
    id: 4,
    name: 'Google Ads Audience Sync',
    connection: 'Google Ads',
    direction: 'Outbound',
    schedule: 'Every 6 hours',
    lastRun: '3 hours ago',
    nextRun: 'In 3 hours',
    status: 'active',
    recordsProcessed: 567,
    duration: '45s'
  }, {
    id: 5,
    name: 'Salesforce Sandbox Test',
    connection: 'Salesforce Sandbox',
    direction: 'Bidirectional',
    schedule: 'Manual',
    lastRun: '2 days ago',
    nextRun: 'Manual trigger',
    status: 'paused',
    recordsProcessed: 0,
    duration: '0s'
  }];
  const syncHistory = [{
    id: 1,
    sync: 'Salesforce Accounts Sync',
    timestamp: '2024-01-20 14:50',
    status: 'success',
    records: 1247,
    duration: '2m 34s',
    errors: 0
  }, {
    id: 2,
    sync: 'HubSpot Contacts Import',
    timestamp: '2024-01-20 14:45',
    status: 'success',
    records: 892,
    duration: '1m 12s',
    errors: 0
  }, {
    id: 3,
    sync: 'Marketo Leads Export',
    timestamp: '2024-01-20 02:00',
    status: 'warning',
    records: 3421,
    duration: '5m 18s',
    errors: 3
  }, {
    id: 4,
    sync: 'Google Ads Audience Sync',
    timestamp: '2024-01-20 11:00',
    status: 'success',
    records: 567,
    duration: '45s',
    errors: 0
  }];
  return <div className="space-y-6" data-id="element-1813">
      {/* Summary Cards */}
      <div className="grid grid-cols-4 gap-4" data-id="element-1814">
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1815">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1816">Active Syncs</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-1817">4</p>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1818">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1819">Records Today</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-1820">6.1K</p>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1821">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1822">Avg Duration</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-1823">2m 24s</p>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1824">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1825">Success Rate</p>
          <p className="text-3xl font-bold text-green-600" data-id="element-1826">98.5%</p>
        </div>
      </div>
      {/* Sync Configurations */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1827">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-1828">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-1829">
            Sync Configurations
          </h3>
          <button className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium" data-id="element-1830">
            <PlusIcon className="w-4 h-4" data-id="element-1831" />
            Create Sync
          </button>
        </div>
        <table className="w-full" data-id="element-1832">
          <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1833">
            <tr data-id="element-1834">
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1835">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1836">
                Connection
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1837">
                Direction
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1838">
                Schedule
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1839">
                Last Run
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1840">
                Next Run
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1841">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1842">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1843">
            {syncs.map(sync => <tr key={sync.id} className="hover:bg-gray-50" data-id="element-1844">
                <td className="px-6 py-4" data-id="element-1845">
                  <span className="text-sm font-medium text-gray-900" data-id="element-1846">
                    {sync.name}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1847">
                  <span className="text-sm text-gray-700" data-id="element-1848">
                    {sync.connection}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1849">
                  <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-medium" data-id="element-1850">
                    {sync.direction}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1851">
                  <div className="flex items-center gap-2" data-id="element-1852">
                    <ClockIcon className="w-4 h-4 text-gray-400" data-id="element-1853" />
                    <span className="text-sm text-gray-700" data-id="element-1854">
                      {sync.schedule}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-1855">
                  <span className="text-sm text-gray-700" data-id="element-1856">{sync.lastRun}</span>
                </td>
                <td className="px-6 py-4" data-id="element-1857">
                  <span className="text-sm text-gray-700" data-id="element-1858">{sync.nextRun}</span>
                </td>
                <td className="px-6 py-4" data-id="element-1859">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${sync.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-1860">
                    {sync.status}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1861">
                  <div className="flex items-center gap-2" data-id="element-1862">
                    <button className="p-1.5 hover:bg-gray-100 rounded transition-colors" title="Run Now" data-id="element-1863">
                      <RefreshCwIcon className="w-4 h-4 text-gray-600" data-id="element-1864" />
                    </button>
                    {sync.status === 'active' ? <button className="p-1.5 hover:bg-gray-100 rounded transition-colors" title="Pause" data-id="element-1865">
                        <PauseIcon className="w-4 h-4 text-gray-600" data-id="element-1866" />
                      </button> : <button className="p-1.5 hover:bg-gray-100 rounded transition-colors" title="Resume" data-id="element-1867">
                        <PlayIcon className="w-4 h-4 text-gray-600" data-id="element-1868" />
                      </button>}
                    <button className="p-1.5 hover:bg-gray-100 rounded transition-colors" title="Schedule" data-id="element-1869">
                      <CalendarIcon className="w-4 h-4 text-gray-600" data-id="element-1870" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      {/* Sync History */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1871">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-1872">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-1873">Sync History</h3>
        </div>
        <table className="w-full" data-id="element-1874">
          <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1875">
            <tr data-id="element-1876">
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1877">
                Sync Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1878">
                Timestamp
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1879">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1880">
                Records
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1881">
                Duration
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1882">
                Errors
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1883">
            {syncHistory.map(history => <tr key={history.id} className="hover:bg-gray-50" data-id="element-1884">
                <td className="px-6 py-4" data-id="element-1885">
                  <span className="text-sm font-medium text-gray-900" data-id="element-1886">
                    {history.sync}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1887">
                  <span className="text-sm text-gray-700" data-id="element-1888">
                    {history.timestamp}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1889">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${history.status === 'success' ? 'bg-green-100 text-green-700' : history.status === 'warning' ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700'}`} data-id="element-1890">
                    {history.status}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1891">
                  <span className="text-sm text-gray-900" data-id="element-1892">
                    {history.records.toLocaleString()}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1893">
                  <span className="text-sm text-gray-900" data-id="element-1894">
                    {history.duration}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1895">
                  <span className={`text-sm font-medium ${history.errors > 0 ? 'text-red-600' : 'text-gray-900'}`} data-id="element-1896">
                    {history.errors}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}